export default __webpack_public_path__ + "static/media/social-media-bg.f452d92d.png";